// extracted by mini-css-extract-plugin
export default {"root":"style_root__b0cyR","image":"style_image__HnUrO","loader":"style_loader__wEKxa","processingImage":"style_processingImage__oInH8","shine":"style_shine__yZQyl"};